import type { MRT_ColumnDef } from "mantine-react-table-open";
import { CLUSTERS } from "../../Todos.constants";
import type { TodoTableTodo } from "../TodoTable";

function getClusterColumn(): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Kategorie",
    accessorKey: "cluster",
    accessorFn: (todo: TodoTableTodo) => {
      const categoryKey = Object.keys(CLUSTERS).find(
        (categoryKey) => CLUSTERS[categoryKey].value === todo.cluster
      );
      if (!categoryKey) {
        return "Unbekannt";
      }
      return CLUSTERS[categoryKey].displayName;
    },
    filterVariant: "multi-select"
  };
}

export { getClusterColumn };
